import { AppStandardInsightsPage } from '@mercedes-benz/backstage-plugin-app-standard-insights';
import { PluginTabWrapper } from './PluginTabWrapper';

export const AppStandardInsightsTab = () => (
  <PluginTabWrapper>
    <AppStandardInsightsPage />
  </PluginTabWrapper>
);
